/**
 * Copyright IBM Corp. 2022, 2026
 */

import type { ReactNode } from 'react'
import { CodeBlock } from '@hashicorp/mds-react/components'
import s from './CodeBlock.module.css'

interface CodeBlockBlogProps {
	code: ReactNode
	language: string
	showClipboard: boolean
	filename?: string
}

export default function CodeBlockBlog({
	code,
	language,
	showClipboard,
	filename,
}: CodeBlockBlogProps) {
	return (
		<section className={s.codeBlockContainer}>
			<CodeBlock
				value={code}
				language={language}
				hasCopyButton={showClipboard}
				title={filename}
				hasLineNumbers={false}
			/>
		</section>
	)
}
